import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";


import LoginAlert from "../components/LoginAlert/LoginAlert";
// import useShowModal from "../components/store/useShowModal";


const withAuth = (WrappedComponent) => {
    return (props) => {
        const navigate = useNavigate();

        const isLoggedIn = localStorage.getItem('veeuToken');
        // const showLoginAlert = useShowModal((state) => state.showLoginAlert);
        // const setShowLoginAlert = useShowModal((state) => state.setShowLoginAlert);
        useEffect(() => {
            if (!isLoggedIn) {
                // setShowLoginAlert(true);
                navigate("/LoginStepOne"); 
            }
        }, [isLoggedIn, navigate]);

        return (
            <>
                {/* {showLoginAlert && (
                    <LoginAlert
                        showLoginAlert={showLoginAlert}
                        setShowLoginAlert={setShowLoginAlert}>
                        <p>برای ادامه فرایند وارد شوید</p>
                    </LoginAlert>
                )} */}
                {isLoggedIn && <WrappedComponent {...props} />}
            </>
        );
    };
};

export default withAuth;
